export const getUserHasAppGovernanceWriteScope = userInfo => {
  var _userInfo$user;
  return userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 || (_userInfo$user = _userInfo$user.scopes) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.includes('app-governance-write');
};